import React, { Suspense } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import makeStyles from "@material-ui/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import Video from "./video";
import Arrows from "./arrows";
import ReactHTMLPicture from "@micado-digital/react-htmlpicture/ReactHTMLPicture";

const useStyles = makeStyles(theme => ({
	root: {
		alignItems: "center",
		bottom: 0,
		display: "flex",
		flex: "0 0 100%",
		justifyContent: "center",
		left: 0,
		position: "absolute",
		right: 0,
		top: 0,
		zIndex: 1,
		"& .mco-animation-01__image": {
			position: "relative"
		},
		"& picture": {
			height: "100%",
			opacity: 0,
			transition: theme.transitions.create("opacity", {
				easing: theme.transitions?.easing?.easeIn,
				duration: 1000
			}),
			width: "100%",
			"& img": {
				height: "100%",
				width: "100%"
			}
		}
	},
	show: {
		zIndex: 2,
		"& picture": {
			opacity: 1
		}
	},
	image: {
		position: "relative",
		zIndex: 1
	},
	texts: {
		position: "absolute",
		zIndex: 2
	},
	smallerAnimationText: {}
}));

const SlideItem = ({
	active,
	absoluteMediaURLs,
	entries,
	handleArrowChange,
	SliderID,
	media,
	mediaFormats,
	playAnimation,
	stopAnimation,
	show = true,
	texts,
	textsLength,
	textStyles,
	webpFallback
}) => {
	const { REACT_APP_PATH } = process.env;
	const screenMD = useMediaQuery(theme => theme.breakpoints.up("md"));
	const { mediaType } = media || {};
	const css = useStyles();

	const handleChange = id => {
		handleArrowChange(id);
	};

	return (
		<div
			className={clsx("mco-animation-01__slide-item", {
				[css.root]: true,
				"mco-animation-01__slide-item--active": show,
				[css.show]: show,
				"mco-animation-01__slide-item-background": textsLength > 1
			})}
		>
			<div className="mco-animation-01__image">
				{entries > 1 && !screenMD && (
					<Suspense fallback={<></>}>
						<Arrows
							active={active}
							entries={entries}
							onChange={SliderID => handleChange(SliderID)}
						/>
					</Suspense>
				)}
				{mediaType === "image" && (
					<ReactHTMLPicture
						className={css.image}
						lazy={false}
						media={media}
						path={!absoluteMediaURLs ? REACT_APP_PATH : ""}
						webpFallback={webpFallback}
						{...mediaFormats}
					/>
				)}
				{["youtubevideo", "videofile"].indexOf(mediaType) > -1 && (
					<Video
						absoluteMediaURLs={absoluteMediaURLs}
						media={media}
						playAnimation={playAnimation}
						show={show}
						stopAnimation={stopAnimation}
						type={mediaType}
					/>
				)}
			</div>
			{!!texts && (
				<div className={clsx("mco-animation-01__texts", css.texts)}>
					{texts.map(({ text }, index) => {
						return (
							<Typography
								className={clsx(
									"mco-animation-01__text",
									`mco-animation-01__text--${index + 1}`,
									{ "mco-animation-01__text--1-small": text?.length > 100 }
								)}
								component={
									index + 1 === 1
										? textStyles?.textComponents?.text1
										: textStyles?.textComponents?.text2
								}
								variant={
									index + 1 === 1
										? textStyles?.textVariants?.text1
										: textStyles?.textVariants?.text2
								}
								dangerouslySetInnerHTML={{ __html: text }}
								key={index}
							/>
						);
					})}
				</div>
			)}
		</div>
	);
};

SlideItem.propTypes = {
	absoluteMediaURLs: PropTypes.bool,
	media: PropTypes.object,
	mediaFormats: PropTypes.object,
	show: PropTypes.bool,
	texts: PropTypes.array,
	webpFallback: PropTypes.bool
};

export default SlideItem;
